import { useTheme } from '@components/theme';
import classNames from 'classnames';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';

interface INextButton {
  className?: string;
  link?: string;
  isDisabled?: boolean;
  isBusy?: boolean;
  onClick?: () => void;
  text?: string;
}
export default function NextButton({
  className = '',
  link,
  isDisabled = false,
  isBusy = false,
  onClick,
  text
}: INextButton) {
  const theme = useTheme();
  const router = useRouter();

  useEffect(() => {
    if (link) {
      router.prefetch(link);
    }
  }, [link]);

  const navigateToLink = () => {
    if (onClick) onClick();
    if (link) router.push(link);
  };

  const disabled = isDisabled || isBusy;

  return (
    <div className={theme.styles.Container}>
      <button
        type="button"
        data-test="style-quiz-next-button"
        disabled={disabled}
        onClick={() => navigateToLink()}
        className={classNames({
          [className]: !!className,
          [theme.styles.Button]: true,
          [theme.styles.Primary]: true,
          [theme.styles.Disabled]: disabled
        })}
      >
        { text || 'Next' }
      </button>
    </div>
  );
}
